import { motion } from "framer-motion";
import { Sparkle } from "lucide-react";

const ITEMS = [
  "Implantologia Zigomatica",
  "All-on-Four",
  "All-on-Six",
  "Carico Immediato: Denti Fissi in 6 Ore",
  "Invisalign®",
  "TAC 3D in Sede",
  "Parodontologia",
  "Odontoiatria Pediatrica",
  "Impianti Italiani Certificati",
];

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-line bg-teal-mist/50 py-5" data-testid="services-marquee">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div
            key={copy}
            aria-hidden={copy === 1}
            className="flex items-center shrink-0"
          >
            {ITEMS.map((item) => (
              <span
                key={`${copy}-${item}`}
                className="flex items-center gap-8 pr-8 font-display text-lg md:text-xl font-medium italic text-teal-deep whitespace-nowrap"
              >
                {item}
                <Sparkle size={14} className="text-gold shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}